import { render, staticRenderFns } from "./AdminTagChangeHistory.vue?vue&type=template&id=3687b49a&scoped=true"
import script from "./AdminTagChangeHistory.vue?vue&type=script&lang=js"
export * from "./AdminTagChangeHistory.vue?vue&type=script&lang=js"
import style0 from "./AdminTagChangeHistory.vue?vue&type=style&index=0&id=3687b49a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3687b49a",
  null
  
)

export default component.exports